import { useLoadingAnimation } from '@/components/LoadingAnimation/useLoadingAnimation.hook';
import { DEFAULT_ERROR_MESSAGE } from '@/config/text.const';
import { upliftHttpClient } from '@/services/http/clients/upliftHttpClient';
import { notificationService } from '@/services/notification/notification.client';
import { ProcessDocumentResult } from '../abstractions/UpliftUploadedFile.interface';

export interface ProcessFileOptions {
  allowDuplicates?: boolean;
  onAllDuplicates?: (duplicateCount: number) => void;
}

export function useProcessUpliftFile() {
  const { toggleLoadingAnimation } = useLoadingAnimation();

  const processFile = async (id: UUID, callback?: Function, options: ProcessFileOptions = {}) => {
    const { allowDuplicates = false, onAllDuplicates } = options;
    toggleLoadingAnimation(true);

    try {
      const requestUrl = `Documents/process/${id}`;
      const response = await upliftHttpClient.post<ProcessDocumentResult>(requestUrl, null, {
        params: { allowDuplicates }
      });

      const { processedCount, duplicatesSkipped } = response.data ?? {};

      if (processedCount === 0 && duplicatesSkipped?.length > 0) {
        onAllDuplicates?.(duplicatesSkipped.length);
        return;
      } else if (duplicatesSkipped?.length > 0) {
        notificationService.open({
          title: 'Process uplift file',
          text: `File processed with ${processedCount} uplift(s).`
            + ` ${duplicatesSkipped.length} duplicate(s) were skipped.`,
          type: 'warning'
        });
      } else {
        notificationService.open({
          title: 'Process uplift file',
          text: 'File successfully processed',
          type: 'success'
        });
      }

      if (typeof callback === 'function') {
        callback();
      }
    } catch (err: any) {
      notificationService.open({
        title: 'Error',
        text: err?.response?.data?.message ?? err?.message ?? DEFAULT_ERROR_MESSAGE,
        type: 'danger'
      });
    } finally {
      toggleLoadingAnimation(false);
    }
  };

  return {
    processFile
  } as const;
}
